import React, { useEffect } from 'react';

import styles from './DesignersDetailsPage.module.scss';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { DesignersDetailsStore } from '../../store/types';
import { fetchDesignersDetailsProductsData } from 'src/modules/designers';
import {
  // LayoutCardList,
  LayoutCardSize,
  // LayoutBlockTextImage,
  // LayoutCardListHeading,
  // LayoutCardType,
  LayoutDynamicZoneComponentProps,
  LayoutDynamicZone,
} from 'src/modules/layout';
import { useIntl } from 'react-intl';
import { GlobalSpin } from 'src/modules/global';
// import { getProductOverviewImage } from 'src/modules/products';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { ProductsListingOverview } from 'src/modules/products';
import { ArticleListingOverview, ArticleLinkPrefix } from 'src/modules/articles';
import { LayoutBlockHero } from 'src/modules/layout';
import { useRouter } from 'next/router';
import { useLocale, OutputChannels } from 'src/modules/locale';

interface DesignersDetailsPageProps extends DesignersDetailsStore {
  dynamic_content?: LayoutDynamicZoneComponentProps[];
}

const DesignersDetailsPage: React.FunctionComponent<DesignersDetailsPageProps> = (
  props: DesignersDetailsPageProps
) => {
  const intl = useIntl();
  const { getLocalizedObject, outputChannel } = useLocale();
  const {
    designer,
    products,
    articles,
    isLoaded,
    errorProducts,
    isLoadingProducts,
    isLoadedProducts,
    fetchProducts,
  } = getLocalizedObject(props);
  const { dynamic_content } = designer || {};

  //Designer name shouldn't be localised
  const { name: designerName } = props.designer || {};
  const { query } = useRouter();
  useEffect(() => {
    if (!isLoadingProducts && !errorProducts && !isLoadedProducts) {
      fetchProducts(query?.slug);
    }
  }, [fetchProducts, isLoadingProducts, errorProducts, isLoadedProducts, query]);

  if (isLoaded && designer) {
    const breadcrumbs = [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/designers',
        }),
        as: '/designers',
        href: '/designers',
      },
      {
        title: designerName,
        as: `/designers/${encodeURIComponent(designer.slug)}`,
        href: '/designers/[slug]',
      },
    ];

    const designerImage = designer?.assets[0]?.format_3x2;
    return (
      <LayoutPage
        title={
          designerName + (outputChannel === OutputChannels.US ? ' | Walter K.' : ' | Walter Knoll')
        }
        description={designer.description}
        breadcrumbs={breadcrumbs}
        metaImage={designerImage}>
        <section className={styles.container}>
          <LayoutBlockHero
            title={designerName}
            label={intl.formatMessage({ id: 'page/designers/details/designer_profile' })}
            image={designerImage}
            subline={designer?.description}
          />
          {dynamic_content && !!dynamic_content.length && (
            <LayoutDynamicZone
              components={dynamic_content}
              className={styles.dynamicZone}
              groupCards={true}
            />
          )}
          {isLoadingProducts ? (
            <GlobalSpin />
          ) : (
            <ProductsListingOverview
              size={LayoutCardSize.Small}
              headingTitle="page/designers/details/related_products"
              values={{ name: designerName }}
              headingMore={false}
              oneRow={false}
              relatedOverview={true}
              products={products}
            />
          )}

          <ArticleListingOverview
            articles={articles}
            link={ArticleLinkPrefix.article}
            relatedOverview={true}
            oneRow={true}
            size={LayoutCardSize.Small}
          />
        </section>
      </LayoutPage>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.designers.details };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProducts: (slug) => dispatch(fetchDesignersDetailsProductsData(slug)),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DesignersDetailsPage);
